$(document).ready(function(){
  $(document).find('.variant-input-wrapper select').each(function(){
    $(this).find('option:first-child').prop('selected',true);
    $(this).find('option:first-child').attr('disabled');
  })
    
  $(document).on('change','.variant-input-wrapper select',function(){
    $(document).find('.product-form__submit').show();
    $(document).find('.btn-choose-options').hide();
  })

function calculatePrice(){

    $(document).find('.color-side-select ul li').each(function(i,item){
        console.log( $(this).find('input').val() +' '+$(this).find('input').attr('disabled'));
        $(document).find('.color-side-select input').prop('checked', false);
        if( $(this).find('input').attr('disabled') != 'disabled' ){
          $(this).find('input').closest('label').trigger('click');
          return false;
        }
      });
  
  
    var mainPrice = parseInt($('#product_main_price').attr('data-price')),
    symbol = $('#product_main_price').attr('data-symbol');
    if( $(document).find('.bumper-item.bumper-product').hasClass('selected') && !$(document).find('.bumper-design').hasClass('hidden') ){
      mainPrice = mainPrice + parseInt($(document).find('.bumper-design').attr('data-price'));
    }
    $(document).find('.inner-addons .product_item').each(function(i,item){
      if( $(this).find('input[type="checkbox"]').is(':checked') ){
        var price = $(this).attr('data-price');
        mainPrice = mainPrice + parseInt(price);
      }
    });
    console.log(mainPrice);
    var formatedPrice = theme.Currency.formatMoney(mainPrice, theme.settings.moneyFormat);;
    $(document).find('.addcart-btn .btn-price').html(formatedPrice);
  }
  $(document).on('change','.product_item [type=checkbox]',function () {
    calculatePrice()
  });
  $(document).on('click','.bumper-item',function () {
    var parent = $(this).closest('.bumper'); 
    $(parent).find('.bumper-item').removeClass('selected');
    $(this).addClass('selected');
    if( $(this).hasClass('bumper-product') ){
      $('.color-side-select input[value="Clear"],.color-side-select input[value="White"]').attr('disabled','disabled');
      var bumperPricePlus = $('.bumper-design').attr('data-price');
      $(document).find('.addcart-btn .btn-price').html(bumperPricePlus);
      $('.color-side-select').find('input[value="Black"]').prop('checked',true)
      $(document).find('.bumper-input').html('<input type="hidden" name="properties[Bumper upgrade]" value="Yes">') ///Bumper upgrade
    }else if( $(this).hasClass('bumper-product-magsafe') ){
      $('.color-side-select input[value="Clear"],.color-side-select input[value="White"]').attr('disabled','disabled');
      var magPrice = $('.bumper-design').attr('data-mprice');
      $(document).find('.addcart-btn .btn-price').html(magPrice);
      $('.color-side-select').find('input[value="Black"]').prop('checked',true)
      $(document).find('.bumper-input').html('<input type="hidden" name="properties[MagSafe upgrade]" value="Yes">') ///Bumper upgrade
    }else{
      var bumperPricePlus = $('.bumper-design').attr('data-mainPrice');
      $(document).find('.addcart-btn .btn-price').html(bumperPricePlus);
      $('.color-side-select input[value="Clear"],.color-side-select input[value="White"]').removeAttr('disabled');
      $(document).find('.bumper-input').html('')
    }
    calculatePrice();
  });

function checkifBumper(value){
  if( $(document).find('[name="bumper_variant"] option[data-value="'+value+'"]').length > 0 ){
      $('.bumper-design,.bumper-product-impact').removeClass('hidden');
      $(document).find('[name="bumper_variant"] option[data-value="'+value+'"]').prop('selected',true);
    
    }else {
      $('.bumper-design,.bumper-product-impact').addClass('hidden')
      $(document).find('[name="bumper_variant"] option[data-value=""]').prop('selected',true);
    }

    if( $(document).find('[name="mag_variant"] option[data-value="'+value+'"]').length > 0 ){
        $('.bumper-product-magsafe,.bumper-design').removeClass('hidden');
        $(document).find('[name="mag_variant"] option[data-value="'+value+'"]').prop('selected',true);
    }else{
      $('.bumper-product-magsafe').addClass('hidden');
      $(document).find('[name="mag_variant"] option[data-value=""]').prop('selected',true);
    }

    var arrayVals = ['iphone-14','iphone-14-plus', 'iphone-14-pro','iphone-14-pro-max', 'iphone-13', 'iphone-13-pro', 'iphone-13-pro-max', 'iphone-13-mini', 'iphone-12-12-pro', 'iphone-12-pro-max', 'iphone-12-mini','iphone-11', 'iphone-11-pro', 'iphone-11-pro-max', 'iphone-x-xs', 'iphone-xs-max', 'iphone-xr', 'iphone-6-7-8-se', 'iphone-6-plus-7-plus-8-plus','iphone-5-5s-se-2016'];
    var hidden = 0;
    if( $(document).find('.product_item select option[data-value="'+value+'"]').length > 0 ){
      hidden = hidden + 1;
      $(document).find('.product_item select option[data-value="'+value+'"]').prop('selected',true);
      $('[data-handle="tempered-glass-screen-protector"]').removeClass('hidden');
    }else{
      hidden = hidden - 1;
      $('[data-handle="tempered-glass-screen-protector"]').addClass('hidden');
    }

    //$('[data-handle="lightning-cable-1m"]').addClass('hidden');
    //$('[data-handle="usb-c-cable-1m"]').addClass('hidden');

    if($.inArray(value, arrayVals) !== -1){
      $('[data-handle="lightning-cable-1m"]').removeClass('hidden');
      $('[data-handle="usb-c-cable-1m"]').addClass('hidden');
    }else{
      $('[data-handle="lightning-cable-1m"]').addClass('hidden');
      $('[data-handle="usb-c-cable-1m"]').removeClass('hidden');
    }

     $('.addons').removeClass('hidden');
    calculatePrice()
}

var valueBump = $(document).find('.variant-input-wrapper[data-option-index="option1"] .select').val();
    checkifBumper(valueBump)

  $(document).on('change','.variant-input-wrapper[data-option-index="option1"] .select',function(){
    var value = $(this).val();
    console.log(value);
    checkifBumper(value)
  })
$(document).on("click", ".overlay-pop", function () {
    $("#personal-popup").hide();
  });
  $(document).on('click','.free-personalization .btn[data-person="added"]',function(){
    $(this).text( $(this).attr('data-text') );
    $('.initla-hidden-inputs').html('');
    
  });
  $(document).on("click", ".free-personalization .btn", function () {
    var image = $(document).find('.main-product-image').attr('src');
    console.log($(document).find('.product__media.selected img').length)
    if( $(document).find('.product__media.selected img').length > 0 ){
      image = $(document).find('.product__media.selected img').attr('src');
    }
  
    $("#personal-popup").find('.person-image').attr('src',image);
    $("#personal-popup").show();
    $('.tab-pops .tab-popup').hide();
    $('.tab-pops .tab-popup, .buttons-pop ul li').removeClass('selected');
    $('.tab-pops .tab-popup:first-child, .buttons-pop ul li:first-child').show().addClass('selected');
  });

   $(document).on("keyup", "#initials_textinput", function () {
    var text = $(this).val();
     $('.personalization-text').text(text)
  });
  $("#initials_textinput").on("cut copy paste", function (c) {
    c.preventDefault();
});
  $("#initials_textinput").bind("keydown", function (c) {
    switch (c.keyCode) {
        case 8:
        case 9:
        case 13:
        case 37:
        case 38:
        case 39:
        case 40:
            break;
        default:
            if (!RegExp("^[a-zA-Z0-9/]+$").test(c.key)) return c.preventDefault(), alert("Sorry, only letters or numbers allowed. No emojis or special characters"), !1;
    }
});

  $(document).on('change','#initials_position',function(){
    var value = $(this).val();
    if( value == 'middle' ){
      $('.personalization-text').css('top','50%');
    }else if( value == 'top' ){
      $('.personalization-text').css({"top": "15%", "left": "unset", "right" : "30%"});
    }else{
      $('.personalization-text').css({"top": "unset", "left": "505", "right" : "unset", 'bottom':'10%'});
    }
  })

  $(document).on('change','#initials_size',function(){
    var value = $(this).val();
    if( value == 'large' ){
      $('.personalization-text').css('font-size','30px');
    }else if( value == 'medium' ){
      $('.personalization-text').css('font-size','20px');
    }else{
      $('.personalization-text').css('font-size','10px');
    }
  });
  $(document).on('change','#initials_color',function(){
    var value = $(this).val();
    if( value == 'white' ){
      $('.personalization-text').css('color','#fff');
    }else if( value == 'pink' ){
      $('.personalization-text').css('color','#f9c2ff');
    }else if( value == 'grey' ){
      $('.personalization-text').css('color','#999');
    }else if( value == 'blue' ){
      $('.personalization-text').css('color','#a5b0ff');
    }else if( value == 'yellow' ){
      $('.personalization-text').css('color','#feff84');
    }else{
      $('.personalization-text').css('color','#000');
    }
  });

  $(document).on('change','#initials_font',function(){
    var value = $(this).val();
      $('.personalization-text').css('font-family',"'"+value+"'");
  });
  

  
  function addProperties(){
    var name = $('#initials_textinput').val(),
        pos = $('#initials_position').val(),
      size = $('#initials_size').val(),
      color = $('#initials_color').val(),
      font = $('#initials_font').val();
    var htmdld = '<input type="hidden" name="properties[Your initials]" value="'+name+'"><input type="hidden" name="properties[Initials Position]" value="'+pos+'"><input type="hidden" name="properties[Initials Size]" value="'+size+'"><input type="hidden" name="properties[Initials Colour]" value="'+color+'"><input type="hidden" name="properties[Initials Font]" value="'+font+'">'
    $('.initla-hidden-inputs').html(htmdld);
    $('.free-personalization .btn').attr('data-person','added').text( $('.free-personalization .btn').attr('data-rtext') );
    $("#personal-popup").hide();
  }

  function handleTabs(selector, parent, action){
    var textCustom = $('#initials_textinput').val();
    if(textCustom.length > 2){
      alert('Only two characters allowed');
      return false;
    }
    if( $(selector).hasClass('finish-button') ){
      ///DO FINISH TASK
      addProperties();
      return false;
    }
    $(parent).find('.tab-popup').removeClass('selected').hide();
    if(action == 'prev'){
      $(selector).closest('.tab-popup').prev('.tab-popup').show().addClass('selected');
    }else{
      $(selector).closest('.tab-popup').next('.tab-popup').show().addClass('selected');
    }
    
    var selectedTab = $(document).find('.tab-pops .tab-popup.selected').attr('data-tabc');
    $(document).find('.buttons-pop ul li').removeClass('selected');
    $(document).find('.buttons-pop ul li[data-tab="'+selectedTab+'"]').addClass('selected');
    
  }

  
  $(document).on("click", ".cancle-btn", function () {
    $('.initla-hidden-inputs').html('');
    $('.free-personalization .btn').removeAttr('data-person').text( $('.free-personalization .btn').attr('data-text') );
    $("#personal-popup").hide();
  });
  
  $(document).on("click", ".back-button", function () {
    var parent = $(this).closest('.tab-pops');
    handleTabs($(this), parent ,'prev')
  });

  
  
  $(document).on("click", ".tab-popup .btn", function () {
    var selector = $(this),
        parent = $(this).closest('.tab-pops');
    handleTabs(selector, parent ,'next')
  });

  $(".left-tab-main li").on("mouseover", function () {
    var tabInd = $(this).attr("data-tab"),
      parent = $(this).closest(".menu-disp-flex");
    $(parent).find(".menu-items-tabs .menu-tabs").hide();
    $(parent)
      .find('.menu-items-tabs .menu-tabs[data-menu_tab="' + tabInd + '"]')
      .show();
  });
  })